module.exports = {
      id: "icon-playstore-usage",
      viewBox: "0 0 190.654 62.305",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#icon-playstore",
      toString: function () {
        return this.url;
      }
    }